import React, { useEffect, useState, useRef } from 'react';
import { Alert, Collapse, Input, Col, Row, Typography } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { APIs } from '../../utils/constants';
import EditPrompt from '../../components/modal/edit-prompt';
import Text from '../../components/text';
import Button from '../../components/button';

function Prompt() {
    const [errorMessage, setErrorMessage] = useState(null);
    const [prompts, setPrompts] = useState([]);
    const [loading, setLoading] = useState(true);

    const editPromptModal = useRef();

    useEffect(() => {
        fetchPrompts();
    }, []);

    const fetchPrompts = async () => {
        try {
            const response = await fetch(APIs.LIST_PROMPTS, { method: 'Get' });
            const r = await response.json();
            if (response.ok) {
                setPrompts(r);
            } else {
                setErrorMessage(r.message);
            }
        } catch (error) {
            setErrorMessage(error.message);
        }
        setLoading(false);
    };

    const showPromptModal = (prompt) => {
        editPromptModal.current.showModal(prompt, fetchPrompts);
    };

    const collapseItems = prompts.map(prompt => ({
        key: prompt.uuid,
        label: prompt.name,
        children: (
            <Input.TextArea
                value={prompt.value}
                rows={30}
                readOnly
                style={{ resize: 'none' }}
            />
        ),
        extra: (
            <EditOutlined onClick={(e) => {
                e.stopPropagation();
                showPromptModal(prompt);
            }} />
        )
    }));

    return (<>{!loading &&
        <React.Fragment>
            <Row>
                <Col span={18} offset={3}>
                    <Typography.Title>
                        <Text id='admin::prompt::title::prompt' />
                    </Typography.Title>
                    {errorMessage == null ? <>
                        <Collapse accordion items={collapseItems} />
                        <div style={{ textAlign: 'center', marginTop: '24px' }}>
                            <Button type="primary" icon={<PlusOutlined />} onClick={showPromptModal}>
                                <Text id='admin::prompt::button::add-prompt' />
                            </Button>
                        </div>

                        <EditPrompt ref={editPromptModal} />
                    </> : <Alert
                        key={0}
                        message={errorMessage}
                        type='error'
                        closable
                        banner
                    />}

                </Col>
            </Row>
        </React.Fragment>
    }</>);
}

export default Prompt;